import React from 'react';
import { get, toInteger, isUndefined } from 'lodash';
import queryString from 'query-string';

// local dependencies
import { checkout as CheckoutView } from 'ui/views/widgets/checkout';
import { CheckoutService } from 'services/checkout';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { messageBus } from 'core/modules/message-bus';
import * as MESSAGE_BUS_EVENTS from 'constants/message-bus-events';
import { getStore } from 'store';
import { REDUCER } from 'constants/entity-names';
import { withRouter } from 'react-router-dom';

// import * as backRoute from 'utils/backRoute';
import { getBackRouteForCheckoutResolver } from 'resolvers/getBackRouteForCheckout';
import { getAppSyncData } from 'utils/getAppSyncData';

// get store
const store = getStore();

/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { Checkout } from 'ui/containers/Checkout';
 *
 * // render
 * <Checkout propName='propValue'/>
 */
class _Checkout extends React.Component {
    
    /**
     * @param {object} props - props
     */
    constructor( props ) {
        super( props );

        // check if URL container `step` query parameter.
        const queryParams = queryString.parse( this.props.location.search );

        // component state
        this.state = {
            isFetching: true,
            networkStatus: undefined,
            componentData: undefined,
            currentStep: toInteger( get( queryParams, 'step', 1 ) ),
            successView: undefined,
            requestPayload: undefined,
            origin: get( queryParams, 'origin', 'memberManagament' )
        };

		this.data = {
			memberId: isUndefined( this.props.location.state ) ? getAppSyncData( 'memberId' ) : get( this.props.location, 'state.memberId', undefined ),
            patientId: isUndefined( this.props.location.state ) ? getAppSyncData( 'patientId' ) : get( this.props.location, 'state.patientId', undefined )
        };

        // create service instance
        this.checkoutService = new CheckoutService();
        
        // start data fetch
        this.fetchComponentData();

         // bind
        this.__bind();

    }

    /*********************************************/

    /**
     * @desc bind events and methods
     */
    __bind() {
        log.debug( 'Checkout.__bind()' );

        messageBus.on( MESSAGE_BUS_EVENTS.SHOW_CHECKOUT_SUCESS_VIEW, this.onSuccessfulCheckout, this );
        this.onSuccessfulCheckout = this.onSuccessfulCheckout.bind( this );
        this.handleSuccessCheckoutAction = this.handleSuccessCheckoutAction.bind( this );
    }

    /**
     * @desc Fetch component response.
     */
    async fetchComponentData() {
        log.debug( 'CallAuthorizationFlowWidget.fetchComponentData()' );

        // cancel ongoing request
        this.checkoutService.cancel();

        // get ongoing call info from the redux store
        const callId = get( store.getState()[ REDUCER.CALL_STATE ], 'callId', null );
        const callType = get( store.getState()[ REDUCER.CALL_STATE ], 'callType', null );
        const memberId = get( this.data, 'memberId', null );
        const patientId = get( this.data, 'patientId', null );

        // fetch component data
        const { status, data } = await this.checkoutService.fetchComponentData( {
            url: this.props.widget.url,
            data: {
                context: {
                    callId,
                    callType,
                    memberId,
                    patientId
                }
            }
        } );

        // check if response status was success
        if( SERVICE_RESPONSE_STATUS.SUCCESS !== status ) {
            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.FAILURE
            } );
        } else {

            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.SUCCESS,
                componentData: data,
                requestPayload: {
                    context: {
                        callId,
                        callType,
                        memberId,
                        patientId
                    }
                }
            } );
        }
    }

    /**
     * update the success view
     */
    onSuccessfulCheckout( data ) {
        log.debug( 'Checkout.onSuccessfulCheckout()' );

        this.setState( { successView: data } );
    }

    /**
     * handleSuccessCheckoutAction: goBack action, clear the checkout data for store
     */
    handleSuccessCheckoutAction( { action } ) {
        log.debug( 'Checkout.handleSuccessCheckoutAction()' );

        if( 'close' === action.name ) {

            // get back-route payload
            // const backRoutePayload = backRoute.decode( this.props.location );

            // if( ! isEmpty( backRoutePayload ) ) {
            //     return this.props.history.push( backRoutePayload );
            // } else {
            //     this.props.history.goBack();

            // }

            const queryParams = queryString.parse( this.props.location.search );
            const queryState = get( this.props.location, 'state', {} );

            const checkoutBackRoute = getBackRouteForCheckoutResolver( { queryParams, queryState } );
            this.props.history.replace( checkoutBackRoute );
            
        }
    }

    /*********************************************/

    /**
     * @desc When component unmounts, cleanup resouces.
     */
    componentWillUnmount() {
        this.checkoutService.cancel(); // cancel ongoing requests
        messageBus.off( MESSAGE_BUS_EVENTS.SHOW_CHECKOUT_SUCESS_VIEW, this.onSuccessfulCheckout, this );
    }


    /**
     * @desc Render a React view component
     */
    render() {

        return (
            <CheckoutView
                isFetching={ this.state.isFetching }
                networkStatus={ this.state.networkStatus }
                { ...get( this.state, 'componentData', {} ) }
                currentStep={ this.state.currentStep }
                successView={ this.state.successView }
                requestPayload = { this.state.requestPayload }
                onSuccessfulCheckout = { this.handleSuccessCheckoutAction }
            />
        );
    }
}

// set display name
_Checkout.displayName = 'Checkout';

// set default props
_Checkout.defaultProps = {};

// prop types
_Checkout.propTypes = {};

export const Checkout = withRouter( _Checkout );
